import { Phone, Mail, MapPin, Clock } from 'lucide-react';

export const ContactSection = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="py-20 md:py-32 hero-bg"
    >
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
          {/* Left - Contact Form */}
          <div className="opacity-0 animate-fade-in-up">
            <span className="text-sm font-medium tracking-widest uppercase text-orange-500 mb-4 block">
              Get In Touch
            </span>
            <h2
              data-testid="contact-title"
              className="text-4xl md:text-5xl font-bold tracking-tight uppercase text-white mb-6"
            >
              Contact Us
            </h2>
            <p className="text-lg text-slate-400 mb-8">
              Have questions? Need a quote? Reach out to us and we'll get back to you promptly.
            </p>

            {/* Contact Form */}
            <form data-testid="contact-form" className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <input
                    type="text"
                    placeholder="Your Name"
                    data-testid="contact-name-input"
                    className="w-full bg-transparent border-2 border-slate-700 text-white placeholder-slate-500 px-4 py-4 rounded-none focus:border-orange-500 focus:outline-none transition-colors"
                  />
                </div>
                <div>
                  <input
                    type="email"
                    placeholder="Your Email"
                    data-testid="contact-email-input"
                    className="w-full bg-transparent border-2 border-slate-700 text-white placeholder-slate-500 px-4 py-4 rounded-none focus:border-orange-500 focus:outline-none transition-colors"
                  />
                </div>
              </div>
              <div>
                <input
                  type="text"
                  placeholder="Subject"
                  data-testid="contact-subject-input"
                  className="w-full bg-transparent border-2 border-slate-700 text-white placeholder-slate-500 px-4 py-4 rounded-none focus:border-orange-500 focus:outline-none transition-colors"
                />
              </div>
              <div>
                <textarea
                  placeholder="Your Message"
                  rows={5}
                  data-testid="contact-message-input"
                  className="w-full bg-transparent border-2 border-slate-700 text-white placeholder-slate-500 px-4 py-4 rounded-none focus:border-orange-500 focus:outline-none transition-colors resize-none"
                ></textarea>
              </div>
              <button
                type="button"
                data-testid="contact-submit-btn"
                className="btn-lift inline-flex items-center justify-center gap-2 bg-orange-500 text-white font-bold tracking-wider uppercase px-8 py-4 rounded-none cursor-default"
              >
                Send Message
              </button>
            </form>
          </div>

          {/* Right - Contact Info */}
          <div className="opacity-0 animate-fade-in-up animate-delay-200">
            <div className="bg-slate-800/50 backdrop-blur-sm p-8 md:p-12 rounded-sm h-full">
              <h3 className="text-2xl font-bold text-white mb-8 uppercase tracking-tight">
                Contact Information
              </h3>

              <div className="space-y-8">
                {/* Phone */}
                <div className="flex items-start gap-4" data-testid="contact-phone">
                  <div className="w-12 h-12 bg-orange-500 rounded-sm flex items-center justify-center flex-shrink-0">
                    <Phone className="h-6 w-6 text-white" />
                  </div>
                  <div>
                    <div className="text-slate-400 text-sm uppercase tracking-wider mb-1">Phone</div>
                    <div className="text-2xl font-bold text-white">091363 51639</div>
                  </div>
                </div>

                {/* Email */}
                <div className="flex items-start gap-4" data-testid="contact-email">
                  <div className="w-12 h-12 bg-orange-500 rounded-sm flex items-center justify-center flex-shrink-0">
                    <Mail className="h-6 w-6 text-white" />
                  </div>
                  <div>
                    <div className="text-slate-400 text-sm uppercase tracking-wider mb-1">Email</div>
                    <div className="text-xl font-bold text-white">info@tejasinfosolutions.com</div>
                  </div>
                </div>

                {/* Location */}
                <div className="flex items-start gap-4" data-testid="contact-location">
                  <div className="w-12 h-12 bg-orange-500 rounded-sm flex items-center justify-center flex-shrink-0">
                    <MapPin className="h-6 w-6 text-white" />
                  </div>
                  <div>
                    <div className="text-slate-400 text-sm uppercase tracking-wider mb-1">Location</div>
                    <div className="text-xl font-bold text-white">Bengaluru, Karnataka</div>
                  </div>
                </div>

                {/* Business Hours */}
                <div className="flex items-start gap-4" data-testid="contact-hours">
                  <div className="w-12 h-12 bg-orange-500 rounded-sm flex items-center justify-center flex-shrink-0">
                    <Clock className="h-6 w-6 text-white" />
                  </div>
                  <div>
                    <div className="text-slate-400 text-sm uppercase tracking-wider mb-1">Business Hours</div>
                    <div className="text-xl font-bold text-white">Mon - Sat: 10AM - 7PM</div>
                  </div>
                </div>
              </div>

              {/* Divider */}
              <div className="border-t border-slate-700 my-8"></div>

              {/* Trust badges */}
              <div className="flex flex-wrap gap-4">
                <span className="bg-slate-700/50 text-slate-300 px-4 py-2 rounded-full text-sm font-medium">
                  Trusted Since 2012
                </span>
                <span className="bg-slate-700/50 text-slate-300 px-4 py-2 rounded-full text-sm font-medium">
                  Authorized Dealer
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
